import { makeStyles } from '@material-ui/core/styles';

const useProfileTableStyles = makeStyles({
  table: {
    marginTop: 20,
    marginBottom: 40,
    width: '80%'
  },
  title: {
    backgroundColor: '#ececec',
    width: '30%'
  },

  title2: {
    backgroundColor: '#ececec',
    width: '70%'
  },

});

export default useProfileTableStyles;
